import { __decorate } from "tslib";
import builderModalBannerView from './builderModalBannerView.html';
import './builderModalBanner.scss';
import { Component } from 'decorators';
let BuilderModalBannerComponent = class BuilderModalBannerComponent {
    async _confirm() {
        this.confirm({ block: this.block });
    }
};
BuilderModalBannerComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: builderModalBannerView,
        bindings: {
            title: '@',
            description: '@',
            button: '@',
            link: '@',
            icon: '@',
            block: '<',
            confirm: '&',
        },
        transclude: true,
    })
], BuilderModalBannerComponent);
export { BuilderModalBannerComponent };
